import React from 'react';
import { useHfsOperationsTimeoutController } from '~/domain/assets/hooks/use-hfs-operations-timeout-controller';
import OperationFailureIndicator from '~/domain/assets/components/OperationFailureIndicator/OperationFailureIndicator';
import MissionSettingsOperationResultIndication from '~/domain/roboticmower-details/components/MowerSettingsOperationResultIndication/MissionSettingsOperationResultIndication';
import { useHfsOperationsPayloadsRetention } from '~/domain/assets/hooks/use-hfs-operations-payloads-retention';
import { useHfsOperationsStatusSynchronizer } from '~/domain/assets/hooks/use-hfs-operations-status-synchronizer';
import MowerSettingsOperationResultIndication from '~/domain/roboticmower-details/components/MowerSettingsOperationResultIndication/MowerSettingsOperationResultIndication';

export const AssetOperationStatusObserver = () => {
  useHfsOperationsPayloadsRetention();
  useHfsOperationsTimeoutController();
  useHfsOperationsStatusSynchronizer();

  return (
    <>
      <OperationFailureIndicator />
      <MissionSettingsOperationResultIndication />
      <MowerSettingsOperationResultIndication />
    </>
  );
};

export default AssetOperationStatusObserver;
